import React, { useEffect } from 'react'
import Gap from './Gap'
import {
  acquireBottomImmersive,
  releaseBottomImmersive,
} from '../utils/flutterStatusBar'

interface ConfirmDialogProps {
  isOpen: boolean
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancel,
}) => {
  // 팝업 열릴 때 네이티브 상태바도 어둡게 (웹 오버레이가 못 덮는 상태바 영역까지 dim 느낌)
  // 센터 다이얼로그: 열릴 때 하단 SafeArea도 해제해 dim이 홈 인디케이터까지 덮게 한다.
  // (다이얼로그는 화면 중앙이라 콘텐츠가 인디케이터에 안 겹침. 바텀시트는 호출 안 함.)
  useEffect(() => {
    if (!isOpen) return
    acquireBottomImmersive()
    return () => releaseBottomImmersive()
  }, [isOpen])

  if (!isOpen) return null

  return (
    <>
      <div
        className="fixed inset-0 z-[1070] bg-black bg-opacity-40"
        onClick={onCancel}
      />

      <div className="fixed inset-0 z-[1070] flex items-center justify-center px-18px">
        <div
          className={`
            w-full
            max-w-[333px]
            rounded-12px
            bg-white
            px-18px
            pt-24px
            pb-24px
            flex
            flex-col
            items-center
          `}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col items-center w-full">
            {title?.trim() ? (
              <>
                <p
                  className={`
                    font-pretendard
                    font-700
                    text-16px
                    text-center
                    text-brown-80%-main
                  `}
                >
                  {title}
                </p>
                <Gap height={8} />
              </>
            ) : null}
            <p
              className={`
                font-pretendard
                font-700
                text-16px
                text-center
                text-brown-80%-main
                whitespace-pre-line
              `}
            >
              {message}
            </p>
          </div>

          <Gap height={24} />

          <div className="w-full flex gap-8px">
            <button
              type="button"
              onClick={onCancel}
              className={`
                flex-1
                h-44px
                rounded-12px
                bg-472410-10%
                font-pretendard
                font-700
                text-16px
                text-brown-80%-main
                flex
                items-center
                justify-center
              `}
            >
              {cancelText}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={`
                flex-1
                h-44px
                rounded-12px
                bg-brown-80%-main
                font-pretendard
                font-bold
                text-16px
                text-white
                flex
                items-center
                justify-center
              `}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmDialog
